import { axios, baseURL } from '@/plugins/axios.js'
import { DirectUpload } from '@rails/activestorage'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    checkoutFeed(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .post('api/v1/checkouts/feed', params)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    attachedImages(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .get('api/v1/attached_images', params)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    updateAttachedImage(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .put(`api/v1/attached_images/${params.id}`, params)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    removeAttachedImage(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`/api/v1/attached_images/${params.id}`, {params})
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    customerRating(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .put(`api/v1/customer_ratings/${params.id}`, params)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    directUploadCheckoutImage(ctx, file) {
      return new Promise((resolve, reject) => {
        const url = `${baseURL}/direct_uploads?referer=checkout_image`
        const upload = new DirectUpload(file, url, {
          directUploadWillCreateBlobWithXHR: xhr => {
            const authHeaders = $cookies.get('userAuth')
            if (authHeaders) {
              xhr.setRequestHeader('access-token', authHeaders['access-token'])
              xhr.setRequestHeader('token-type', authHeaders['token-type'])
              xhr.setRequestHeader('client', authHeaders.client)
              xhr.setRequestHeader('expiry', authHeaders.expiry)
              xhr.setRequestHeader('uid', authHeaders.uid)
            }
          },
        })

        upload.create((error, blob) => {
          if (error) reject(error)
          else resolve(blob)
        })
      })
    },
  }
}